(function() {
    'use strict';
    angular
        .module('emarket.main.category')
        .controller('CategoryController', ['$scope', '$rootScope', '$state', '$location', '$mdMedia', 'Category', function($scope,
            $rootScope,
            $state,
            $location,
            $mdMedia,
            Category) {
            var vm = this;
            var categories;
            var parentCategories;
            vm.isMobile = $mdMedia('xs') || $mdMedia('sm');
            if (vm.isMobile) {
                var parent = $location.search().categoria || 0;
                vm.categories = Category.$search({ $sort: 'name', parentId: parent });
                if (parent !== 0) {
                    vm.parent = Category.$find(parent);
                }
            } else {
                Category.$search({ $sort: 'name' })
                    .$asPromise()
                    .then(function(cats) {
                        categories = cats;
                        parentCategories = categories.filter(function(category) {
                            return !category.parentId;
                        });
                        vm.categories = parentCategories;
                    });
            }

            vm.onCategoryChoose = function(category) {
                if (category.parentId) {
                    $state.go('main.post.search', { categoria: category.slug });
                } else {
                    vm.parent = category;
                    $state.go('main.category', { categoria: category._id });
                }
            };
            vm.getChilds = function(parent) {
                return categories.filter(function(category) {
                    return category.parentId === parent._id;
                });
            };
        }]);
}());
